import { Providers } from "@/app/providers";
import { AppRouter } from "@/app/routes";
import { ErrorBoundary } from "@/components/ErrorBoundary";

/** Root application component. Wraps the router in all required providers. */
export function App() {
  return (
    <ErrorBoundary>
      <Providers>
        <AppRouter />
      </Providers>
    </ErrorBoundary>
  );
}
